"use client";const e=(e,t)=>e?"boolean"==typeof e?t:Object.entries(e).filter((e=>{let[t,n]=e;return n})).map((e=>{let[n]=e;return"".concat(t,"-").concat(n)})).join(" "):"";export{e as default};
